__turbopack_context__.v({
  "reviewSliderStylingOverride": "Kp1FWq_reviewSliderStylingOverride",
});
